import React from 'react';
import { PlusCircle, HelpCircle, ShieldCheck } from 'lucide-react';
import Tooltip from '../../../../../components/ui/Tooltip';

/**
 * Компонент секции дополнительных расходов
 */
const AdditionalCostsSection = ({ formData, handleInputChange, errors }) => {
  return (
    <fieldset className="mb-8">
      <div className="flex items-center justify-between mb-5">
        <legend className="text-xl font-medium text-gray-800 dark:text-gray-200 flex items-center gap-2">
          <PlusCircle className="w-5 h-5 text-orange-500"/>
          Дополнительные расходы
        </legend>
      </div>
      <div className="space-y-5 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-md border dark:border-gray-700">
        {/* Страхование */}
        <div className="flex items-start sm:items-center justify-between flex-col sm:flex-row gap-3">
          <div className="flex items-center flex-grow">
            <input
              type="checkbox" id="includeInsurance" name="includeInsurance"
              checked={formData.includeInsurance} onChange={handleInputChange}
              className="form-checkbox mt-0.5 sm:mt-0 flex-shrink-0"
            />
            <label htmlFor="includeInsurance" className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer select-none">
              Ежегодное страхование (% от остатка долга)
            </label>
            <Tooltip text="Страхование жизни, здоровья или имущества. Рассчитывается ежемесячно как % годовых от текущего остатка долга.">
              <button 
                type="button" 
                aria-label="Информация о страховании" 
                className="ml-1 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none"
              >
                <HelpCircle className="w-4 h-4 cursor-help" />
              </button>
            </Tooltip>
          </div>
          {formData.includeInsurance && (
            <div className="w-full sm:w-auto sm:max-w-[150px] flex-shrink-0">
              <div className="relative rounded-md shadow-sm">
                <input
                  type="text" id="insuranceRate" name="insuranceRate" inputMode="decimal"
                  value={formData.insuranceRate} onChange={handleInputChange}
                  className={`form-input w-full pl-4 pr-10 ${errors.insuranceRate ? 'input-error' : ''}`}
                  placeholder="0.5" required={formData.includeInsurance}
                  aria-invalid={!!errors.insuranceRate} aria-describedby="insuranceRate-error"
                />
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                  <span className="text-gray-500 dark:text-gray-400 sm:text-sm">%</span>
                </div>
              </div>
              {errors.insuranceRate && (
                <p id="insuranceRate-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
                  {errors.insuranceRate}
                </p>
              )}
            </div>
          )}
        </div>
        
        {/* Другие расходы */}
        <div className="flex items-start sm:items-center justify-between flex-col sm:flex-row gap-3">
          <div className="flex items-center flex-grow">
            <input
              type="checkbox" id="includeOtherCosts" name="includeOtherCosts"
              checked={formData.includeOtherCosts} onChange={handleInputChange}
              className="form-checkbox mt-0.5 sm:mt-0 flex-shrink-0"
            />
            <label htmlFor="includeOtherCosts" className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer select-none">
              Разовые расходы при оформлении
            </label>
            <Tooltip text="Единовременные расходы в начале кредита: оценка недвижимости, госпошлины, услуги нотариуса и т.п.">
              <button 
                type="button" 
                aria-label="Информация о разовых расходах" 
                className="ml-1 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none"
              >
                <HelpCircle className="w-4 h-4 cursor-help" />
              </button>
            </Tooltip>
          </div>
          {formData.includeOtherCosts && (
            <div className="w-full sm:w-auto sm:max-w-[150px] flex-shrink-0">
              <div className="relative rounded-md shadow-sm">
                <input
                  type="text" id="otherCostsAmount" name="otherCostsAmount" inputMode="decimal"
                  value={formData.otherCostsAmount} onChange={handleInputChange}
                  className={`form-input w-full pl-4 pr-10 ${errors.otherCostsAmount ? 'input-error' : ''}`}
                  placeholder="10 000" required={formData.includeOtherCosts}
                  aria-invalid={!!errors.otherCostsAmount} aria-describedby="otherCostsAmount-error"
                />
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                  <span className="text-gray-500 dark:text-gray-400 sm:text-sm">₽</span>
                </div>
              </div>
              {errors.otherCostsAmount && (
                <p id="otherCostsAmount-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
                  {errors.otherCostsAmount}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </fieldset>
  );
};

export default AdditionalCostsSection;